import { useState } from "react";
import {
    FaBell,
    FaShoppingBag,
    FaGift,
    FaMoneyBillWave,
    FaStar,
    FaBullhorn,
    FaVolumeUp,
    FaMobileAlt,
} from "react-icons/fa";

import "./NotificationSettings.css";

function NotificationSettings() {

    const [settings, setSettings] = useState({

        orderUpdates: true,

        promotions: true,

        paymentAlerts: true,

        reviewReminder: true,

        marketing: false,

        sound: true,

        vibration: true,

    });

    const toggle = (key) => {

        setSettings((prev) => ({

            ...prev,

            [key]: !prev[key],

        }));

    };

    const Item = ({ icon, title, subtitle, value, onChange }) => (

        <div className="customer-notification-item">

            <div className="customer-notification-left">

                <div className="customer-notification-icon">

                    {icon}

                </div>

                <div>

                    <h4>{title}</h4>

                    <p>{subtitle}</p>

                </div>

            </div>

            <label className="switch">

                <input
                    type="checkbox"
                    checked={value}
                    onChange={onChange}
                />

                <span className="slider"></span>

            </label>

        </div>

    );

    return (

        <div className="customer-notification-settings">

            <div className="customer-notification-header">

                <FaBell />

                <div>

                    <h2>Notification Settings</h2>

                    <p>

                        Control which notifications you receive.

                    </p>

                </div>

            </div>

            <div className="customer-notification-card">

                <Item
                    icon={<FaShoppingBag />}
                    title="Order Updates"
                    subtitle="Order status and delivery updates"
                    value={settings.orderUpdates}
                    onChange={() => toggle("orderUpdates")}
                />

                <Item
                    icon={<FaGift />}
                    title="Offers & Coupons"
                    subtitle="Receive offers and discounts"
                    value={settings.promotions}
                    onChange={() => toggle("promotions")}
                />

                <Item
                    icon={<FaMoneyBillWave />}
                    title="Payment Alerts"
                    subtitle="Payment confirmations"
                    value={settings.paymentAlerts}
                    onChange={() => toggle("paymentAlerts")}
                />

                <Item
                    icon={<FaStar />}
                    title="Review Reminder"
                    subtitle="Remind me to review orders"
                    value={settings.reviewReminder}
                    onChange={() => toggle("reviewReminder")}
                />

                <Item
                    icon={<FaBullhorn />}
                    title="Marketing Notifications"
                    subtitle="New restaurants and campaigns"
                    value={settings.marketing}
                    onChange={() => toggle("marketing")}
                />

                <Item
                    icon={<FaVolumeUp />}
                    title="Sound"
                    subtitle="Play notification sound"
                    value={settings.sound}
                    onChange={() => toggle("sound")}
                />

                <Item
                    icon={<FaMobileAlt />}
                    title="Vibration"
                    subtitle="Vibrate on notification"
                    value={settings.vibration}
                    onChange={() => toggle("vibration")}
                />

            </div>

        </div>

    );

}

export default NotificationSettings;